import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';

export interface Props {
  className?: string;
  tooBigClassName?: string;
  maxHeight: number;
}

export interface State {
  isTooBig: boolean;
}

export const AutoSizedText: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  tooBigClassName,
  maxHeight,
}) => {
  const [isTooBig, setIsTooBig] = useState(false);
  const [hasTriggeredResize, setHasTriggeredResize] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = rootRef.current;

    if (!node) {
      return;
    }

    const isTooBigNow = node.getBoundingClientRect().height > maxHeight;
    // hasTriggeredResize here to avoid infinite loops between adding the tooBig class and removing it
    // at certain viewport sizes
    if (isTooBigNow === isTooBig || hasTriggeredResize) {
      return;
    }

    setIsTooBig(isTooBigNow);
    setHasTriggeredResize(true);
  }, [rootRef, isTooBig, hasTriggeredResize, maxHeight]);

  return (
    <h1
      ref={rootRef}
      className={classnames(className, isTooBig && tooBigClassName)}
    >
      {children}
    </h1>
  );
};

export default AutoSizedText;
